import { useContext } from 'react';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { ExtractedAnswersAPI } from '@trinity/chat';
import { ExtractedAnswersAPIContext } from '../contexts/ExtractedAnswersAPIContext';

type Data = ExtractedAnswersAPI.GetExtractedAnswers.Response;
type QueryKey = readonly [string, { transcriptId: number }];
type Options = Omit<UseQueryOptions<Data, Error, Data, QueryKey>, 'queryKey' | 'queryFn'>;

export function useExtractedAnswers(transcriptId: number, options?: Options) {
  const apiContext = useContext(ExtractedAnswersAPIContext);

  if (!apiContext) {
    throw new Error('useExtractedAnswers must be used within an ExtractedAnswersAPIContext.Provider');
  }

  const queryKey = ['transcript:extracted-answers', { transcriptId }] as const;

  return useQuery({
    queryKey,
    queryFn: () => apiContext.getExtractedAnswers({ transcriptId }),
    ...options,
  });
}
